import { environment } from "environments/environment";


export const BASE_SERVER_URL = environment.apiBaseUrl;
export const BASE_API_URL = BASE_SERVER_URL + 'api';
export const SMALL_SCREEN = 576;
export const MEDIUM_SCREEN = 768;
export const LARGE_SCREEN = 992;
export const XLARGE_SCREEN = 1400;
export const MAX_ZOOM_SCREEN = 1400;
